import React, { Component } from "react";
import styled from "styled-components";
import { SiteData } from "react-static";

const Navigation = styled.div`
  height: 5em;
  width: 100%;
  display: flex;
  background: linear-gradient(30deg, rgb(87, 124, 255), rgb(111, 54, 255));
  padding-left: 5em;
  padding-right: 5em;
  box-sizing: border-box;
`;

const StickedNavigation = styled(Navigation)`
  position: fixed;
  max-width: calc(100vw - var(--scrollbar-width));
  top: 0;
  z-index: 1000;
`;

const FluentNavigation = styled(Navigation)`
  position: absolute;
  bottom: 0;
  z-index: 800;
`;

const Justify = styled.div`
  width: 100%;
  height: 100%;
  display: inline-grid;
  grid-auto-flow: column;
  justify-items: center;
  grid-auto-columns: 1fr;
`;

const Title = styled.div`
  font-family: "Raleway", sans-serif;
  font-size: 1.5em;
  font-weight: 700;
  color: white;
  padding: 0.5em 1em 0.5em 1em;
  align-self: center;
  justify-self: center;
  white-space: nowrap;

  @media (max-width: 485px) {
    display: none;
  }
`;

const Link = styled.a`
  cursor: pointer;
  font-family: "Raleway", sans-serif;
  font-size: 1em;
  font-weight: 700;
  color: rgb(217, 211, 232);
  height: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  pointer-events: "all";
  width: 100%;
  text-align: center;
  text-decoration: none;
`;

const FluentLink = styled(Link)`
  pointer-events: "none";

  &:not(:first-child):not(:last-child) {
    width: 20em;
    height: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
    color: rgb(115, 126, 255);
    pointer-events: none;

    &:after {
      width: 20em;
      height: 20em;
      display: block;
      position: absolute;
      content: "";
      border-radius: 50%;
      background-color: white;
      box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.25);
      top: -25%;
      left: 0%;
      z-index: -1;
      pointer-events: all;
    }
  }

  &:first-child:after {
    left: 0;
  }

  &:last-child:after {
    right: 0;
  }

  &:first-child:after,
  &:last-child:after {
    position: absolute;
    content: "";
    width: 50%;
    pointer-events: all;
    height: 100%;
  }
`;

export const links = [
  {
    href: "#praxen",
    children: "Praxen"
  },
  {
    href: "#leistungen",
    children: "Unsere Leistungen"
  },
  {
    href: "#team",
    children: "Team"
  },
  {
    href: "#kontakt",
    children: "Kontakt"
  }
];

export const StickedNavbar = ({ links }) => (
  <SiteData
    render={({ title }) => (
      <StickedNavigation>
        <Title children={title} />
        <Justify>
          {links.map(link => <Link key={links.indexOf(link)} {...link} />)}
        </Justify>
      </StickedNavigation>
    )}
  />
);

// maybe without justify and just with justify-items: space-around ?
// look up prior builds on netlify

export const FluentNavbar = ({ links }) => (
  <FluentNavigation>
    <Justify>
      <FluentLink {...links[2]} />
      <FluentLink {...links[0]} />
      <FluentLink {...links[1]} />
    </Justify>
  </FluentNavigation>
);



// WEBPACK FOOTER //
// /opt/build/repo/src/segments/NavbarSegment.js